import React, { useEffect, useState } from "react";
import Svg from "_assets/svg";
import { channelConstant } from "_constant";
import ButtonCustom from "components/ButtonApplicationCard";
import Divider from "components/Divider";
import H1 from "components/H1";
import H3 from "components/H3";
import moment from "moment";
import applicationSvc from "services/applicationSvc";
import styled from "styled-components";
import Wrapper from "./Wrapper";
import ContentWrapper from "./ContentWrapper";
import TextWrapper from "./TextWrapper";
import ButtonDropdown from "./ButtonDropdown";
import Whatsapp from "./sections/Whatsapp";
import Sms from "./sections/Sms";
import Voice from "./sections/Voice";
import TextAreaWrapper from "./TextAreaWrapper";

const WrapperHeader = styled.div`
  width: 100vw;
  background: #ffffff;
  padding: 20px;
  @media only screen and (min-width: 1024px) {
    display: none !important;
  }
`;

const ButtonClose = styled.a`
  background: transparent;
  cursor: pointer;
`;

const DetailApplication = (props) => {
  const [whatsapp, setWhatsapp] = useState(false);
  const [voice, setVoice] = useState(false);
  const [sms, setSms] = useState(false);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const { showDetail, setShowDetail, showDetailId } = props;

  async function getDataById(id){
    setLoading(true);
    if(id){
      try {
        const applicationData = await applicationSvc.getById(id);
        setData(applicationData?.data?.data || []);
        setLoading(false);
      } catch (err) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    getDataById(showDetailId);
  }, [showDetailId]);

  useEffect(() => {
    document.body.style.overflow = showDetail ? "hidden" : "auto";
  }, [showDetail]);

  return (
    <Wrapper showDetail={showDetail} className="position-sticky sticky-with-header">
      <WrapperHeader className="d-flex flex-row justify-content-between">
        <H3>Detail</H3>
        <ButtonClose onClick={() => setShowDetail(false)}>
          <img src={Svg.ic_close.default} alt="close" />
        </ButtonClose>
      </WrapperHeader>
      {loading ? (
        <div>loading...</div>
      ) : (
        <ContentWrapper className="d-flex flex-column">
          <H1 className="margin-bottom-20" style={{ wordBreak: 'break-word' }}>{data.applicationName || data.application_name}</H1>
          <div className="d-flex flex-row" style={{ flexWrap: 'wrap' }}>
            {data?.channels?.map((val) => {
              return (
                <>
                  {val.channel === channelConstant.whatsapp && (
                    <ButtonCustom
                      svg={Svg.whatsapp_primary.default}
                      title="Whatsapp"
                      textColor="#377333"
                      backgroundColor="#DFF3E0"
                      className="margin-right-10 mb-2"
                    />
                  )}
                  {val.channel === channelConstant.sms && (
                    <ButtonCustom
                      svg={Svg.sms_primary.default}
                      title="SMS"
                      textColor="#6F4AAF"
                      backgroundColor="#EAE2F8"
                      className="margin-right-10 mb-2"
                    />
                  )}
                  {val.channel === channelConstant.call && (
                    <ButtonCustom
                      svg={Svg.call_primary.default}
                      title="Call"
                      textColor="#2966BC"
                      backgroundColor="#D7E8FA"
                      className="margin-right-10 mb-2"
                    />
                  )}
                  {val.channel === channelConstant.voiceOtp && (
                    <ButtonCustom
                      svg={Svg.call_primary.default}
                      title="Voice OTP"
                      textColor="#2966BC"
                      backgroundColor="#D7E8FA"
                      className="margin-right-10 mb-2"
                    />
                  )}
                  {val.channel === channelConstant.email && (
                    <ButtonCustom
                      svg={Svg.email.default}
                      title="Email"
                      textColor="#2966BC"
                      backgroundColor="#D7E8FA"
                      className="margin-right-10 mb-2"
                    />
                  )}
                  {/* {val.channel === channelConstant.chatAja && (
                    <ButtonCustom
                      svg={Svg.chat_aja.default}
                      title="Chat Aja"
                      textColor="#2966BC"
                      backgroundColor="#D7E8FA"
                      className="margin-right-10 mb-2"
                    />
                  )} */}
                  {val.channel === channelConstant.smsOtp && (
                    <ButtonCustom
                      svg={Svg.sms_primary.default}
                      title="SMS OTP"
                      textColor="#2966BC"
                      backgroundColor="#D7E8FA"
                      className="margin-right-10 mb-2"
                    />
                  )}
                </>
              );
            })}
          </div>

          <Divider className="margin-bottom-30" />
          <div className="row g-3">
            <TextAreaWrapper className="col-12" title="Application Id" description={decodeURI(data.id || data._id)} />
            <TextAreaWrapper className="col-12" title="Public Key" description={decodeURI(data.publicKey || data.public_key)} />
            <TextWrapper
              title="Key Issued"
              description={moment(data.createdAt).format("ddd, DD/MM/YYYY - hh:mm")}
            />
            {/* <TextWrapper title="Key Issued" description="Tue, 01/12/2021 - 06:56" /> */}
            <TextWrapper title="Expires" description="Never" />
          </div>
          {data?.channels?.map((val) => {
            return (
              <>
                {val.channel === channelConstant.whatsapp && (
                  <div>
                    <Divider />
                    <ButtonDropdown
                      title="Whatsapp"
                      svg={Svg.whatsapp_primary.default}
                      active={whatsapp}
                      onClick={() => setWhatsapp(!whatsapp)}
                    />
                    <Whatsapp data={val} applicationName={data.applicationName} active={whatsapp} />
                  </div>
                )}
                {val.channel === channelConstant.sms && (
                  <div>
                    <Divider />
                    <ButtonDropdown
                      title="SMS"
                      svg={Svg.sms_primary.default}
                      active={sms}
                      onClick={() => setSms(!sms)}
                    />
                    <Sms data={val} active={sms} />
                  </div>
                )}
                {val.channel === channelConstant.call && (
                  <div>
                    <Divider />
                    <ButtonDropdown
                      title="Call"
                      svg={Svg.call_primary.default}
                      active={voice}
                      onClick={() => setVoice(!voice)}
                    />
                    <Voice data={val} active={voice} />
                  </div>
                )}
                {val.channel === channelConstant.voiceOtp && (
                  <div>
                    <Divider />
                    <ButtonDropdown
                      title="Voice OTP"
                      svg={Svg.call_primary.default}
                      active={voice}
                      onClick={() => setVoice(!voice)}
                    />
                    <Voice data={val} active={voice} />
                  </div>
                )}
                {val.channel === channelConstant.email && (
                  <div>
                    <Divider />
                    <ButtonDropdown
                      title="Email"
                      svg={Svg.email.default}
                      active={voice}
                      onClick={() => setVoice(!voice)}
                    />
                    <Voice data={val} active={voice} />
                  </div>
                )}
                {/* {val.channel === channelConstant.chatAja && (
                  <div>
                    <Divider />
                    <ButtonDropdown
                      title="Chat Aja"
                      svg={Svg.chat_aja.default}
                      active={voice}
                      onClick={() => setVoice(!voice)}
                    />
                    <Voice data={val} active={voice} />
                  </div>
                )} */}
                {val.channel === channelConstant.smsOtp && (
                  <div>
                    <Divider />
                    <ButtonDropdown
                      title="SMS OTP"
                      svg={Svg.sms_primary.default}
                      active={voice}
                      onClick={() => setVoice(!voice)}
                    />
                    <Voice data={val} active={voice} />
                  </div>
                )}
              </>
            );
          })}

          <Divider />
        </ContentWrapper>
      )}
    </Wrapper>
  );
};

export default DetailApplication;
